export default class Window {
    static scrollTop () {
        const docElement = document.documentElement
        const scrollTop = (window.pageYOffset || docElement.scrollTop) - (docElement.clientTop || 0)

        return scrollTop
    }

    static addClassToElement (element, className) {
        if (element) element.classList.add(className)
    }

    static removeClassFromElement (element, className) {
        if (element) element.classList.remove(className)
    }

    static addEvent (eventName, callback) {
        window.addEventListener(eventName, callback)
    }

    static removeEvent (eventName, callback) {
        window.removeEventListener(eventName, callback)
    }

    static scrollIntoView (eleID) {
        let e = document.getElementById(eleID)

        if (!!e && e.scrollIntoView) {
            e.scrollIntoView()
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/window.js